/**
 * VolumeControls — the shared Music + SFX volume sliders used by every editor.
 *
 * Presentational only: it owns the layout (two pill rows) and the gradient look
 * so all editors match. Each editor passes its own values + setters (its SFX
 * setter usually also mirrors the volume into its tick/hit-sound engine).
 */

import React from 'react';
import GradientSlider from './GradientSlider';

export interface VolumeControlsProps {
  music: number;
  sfx: number;
  onMusic: (v: number) => void;
  onSfx: (v: number) => void;
}

export default function VolumeControls({ music, sfx, onMusic, onSfx }: VolumeControlsProps) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
      <div style={rowBox}>
        <GradientSlider
          inline
          label="Music"
          value={music}
          onChange={onMusic}
          gradientFrom="#EC4899"
          gradientTo="#EF4444"
        />
      </div>
      <div style={rowBox}>
        <GradientSlider
          inline
          label="SFX"
          value={sfx}
          onChange={onSfx}
          gradientFrom="oklch(0.62 calc(0.18 * var(--accent-c)) var(--accent-h))"
          gradientTo="oklch(0.78 calc(0.215 * var(--accent-c)) var(--accent-h))"
        />
      </div>
    </div>
  );
}

// Inner pill container per slider — matches the Controls/Auto pill look.
const rowBox: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
  background: 'oklch(0.18 calc(0.026 * var(--tint-c)) var(--tint-h) / 0.4)',
  border: '1px solid oklch(0.62 calc(0.11 * var(--tint-c)) var(--tint-h) / 0.15)',
  borderRadius: 999,
  padding: '10px 14px',
};
